var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconKitchenRoom = function SvgIconKitchenRoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-986 -721)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184,192H144v40h40Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1987,6530a3,3,0,0,1-3-3v-18a3,3,0,0,1,3-3h10a3,3,0,0,1,3,3v18a3.006,3.006,0,0,1-3,3Zm-1-3a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-11h-12Zm0-18v5h12v-5a1,1,0,0,0-1-1h-10A1,1,0,0,0-1988,6509Zm8,14v-4a1,1,0,0,1,1-1,1,1,0,0,1,1,1v4a1,1,0,0,1-1,1A1,1,0,0,1-1980,6523Z",
    transform: "translate(2988.001 -5777)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconKitchenRoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-kitchen_room.37b1ff66.svg";
export { ForwardRef as ReactComponent };